import { SessionContext } from '@contexts/session-context';
import { Feature } from '@enums/feature.enum';
import { UseBaseHooks } from '@hooks/use-base.hooks';
import { UserPreference } from '@models/user-preferences.model';
import AmplitudeEventService from '@services/amplitude-event.service';
import UserPreferenceService from '@services/user-preference.service';
import { useContext, useEffect } from 'react';

const Amplitude = () => {
  const sessionContext = useContext(SessionContext);
  const session = sessionContext?.session;
  const { hasFeature } = UseBaseHooks();

  const getAccountId = () => {
    return (
      document.location.host.replace('.testsigma.com', '-') +
      session?.tenant?.identityServiceId +
      ':' +
      session?.user?.identityUserAccountUUId
    );
  };

  const addAmplitude = (userPreference: UserPreference) => {
    const user = session?.user;
    const tenant = session?.tenant;
    const accountId = getAccountId();

    if (window.amplitude) {
      // @ts-ignore
      window.amplitude
        .getInstance()
        .init(import.meta.env.VITE_AMPLITUDE_INSTANCE_ID, accountId);

      // @ts-ignore
      const identify = new amplitude.Identify();
      identify.set('createdDate', user.createdAt);
      identify.set('email', user.email);
      identify.set('domain', user.domain);
      identify.set('isSuperAdmin', user.isSuperAdmin);
      identify.set('plan', tenant?.subscription?.plan);
      identify.set('name', user.firstName + ' ' + user.lastName || user.name);
      identify.set('isAdmin', user.isAdmin);
      identify.set('company', tenant?.company || tenant?.domain);
      identify.set('accountStatus', tenant?.subscription?.status);
      identify.set('userId', accountId);
      identify.set('LastUsedUI', 'LeapUi');
      // @ts-ignore
      amplitude.identify(identify);
    }
  };

  useEffect(() => {
    // Identify the user using Amplitude.
    if (window?.amplitude?.getInstance()) {
      UserPreferenceService.show(session?.user?.id).then((userPreference) => {
        addAmplitude(userPreference);
      });
    }
  }, [session]);

  return null;
};

export default Amplitude;
